/* eslint-env browser, es6 */
import m from "mithril";

import { ApiError } from "../api";

interface ApiErrorViewAttrs {
  error: ApiError;
}

export class ApiErrorView implements m.Component<ApiErrorViewAttrs> {
  view(vnode: m.Vnode<ApiErrorViewAttrs>): m.Children {
    const error = vnode.attrs.error;
    return m("p.error", [
      m("strong", "error:"),
      ` ${error.message} (${error.code})`,
    ]);
  }
}
